import axios from "axios";

/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
  if (timestamp == '' || timestamp == undefined || timestamp == null) {
    return ''
  } else {
    let time = Number(timestamp)
    let date = ''
    if (timestamp.length == 13) {
      date = new Date(time) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    } else {
      date = new Date(timestamp)
    }
    let Y = date.getFullYear() + '-'
    let M =
      (date.getMonth() + 1 < 10 ?
        '0' + (date.getMonth() + 1) :
        date.getMonth() + 1) + '-'
    let D =
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
      (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
      ':'
    let s =
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
  }

};
const timestampToDate = (timestamp) => {
  if (timestamp == '' || timestamp == undefined || timestamp == null) {
    return ''
  } else {
    let time = Number(timestamp)
    let date = new Date(time) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
      (date.getMonth() + 1 < 10 ?
        '0' + (date.getMonth() + 1) :
        date.getMonth() + 1) + '-'
    let D =
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    return Y + M + D
  }
};
const timestampToMonth = (timestamp) => {
  if (timestamp == '' || timestamp == undefined || timestamp == null) {
    return ''
  } else {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
      (date.getMonth() + 1 < 10 ?
        '0' + (date.getMonth() + 1) :
        date.getMonth() + 1)
    return Y + M
  }
};
const copy = (name, phone, addr) => {
  let url = name + ',' + phone + ',' + addr;
  let oInput = document.createElement('input');
  oInput.value = url;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象;
  document.execCommand("Copy"); // 执行浏览器复制命令
  this.$message({
    message: '复制成功',
    type: 'success'
  });
  oInput.remove()
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
  let date = new Date();
  date.setDate(date.getDate() + day);
  document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
  let reg = RegExp(name + '=([^;]+)');
  let arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return '';
  }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, null, -1);
};

const uploadFile = (res, file, type) => {
  return new Promise((resolve, reject) => {
    const fileData = new FormData();
    fileData.append("file", file);
    fileData.append("token", res.content.token);
    if (type == false) {
      fileData.append("isTmp", false);
      fileData.append("urlContainWH", true);
    } else {
      fileData.append("isTmp", true);
      fileData.append("urlContainWH", false);
    }
    fileData.append("waterMarkType", 880);
    fileData.append("waterMarkSwitch", false);
    fileData.append("fontMarkSwitch", false);
    fileData.append("isThumb", false);

    axios.post(res.content.fileUploadUrl, fileData).then(data => {
      resolve(data);
    })
  })
};

/**
 * 导出
 **/
export {
  timestampToTime,
  timestampToDate,
  timestampToMonth,
  copy,
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  delCookie,
  uploadFile
}



// WEBPACK FOOTER //
// ./src/utils/util.js